module.exports = __webpack_public_path__ + "static/media/LCD_3.14d1d1c3.svg";